var map = {
	"./frontend/AndroidGuide.vue": 78905,
	"./frontend/Banking.vue": 38194,
	"./frontend/BetslipHistory.vue": 99809,
	"./frontend/BodyFB.vue": 86498,
	"./frontend/Commission.vue": 85383,
	"./frontend/ContactUs.vue": 94493,
	"./frontend/DataTable.vue": 36107,
	"./frontend/Deposit.vue": 32296,
	"./frontend/History.vue": 31224,
	"./frontend/Home.vue": 75685,
	"./frontend/IOSGuide.vue": 72003,
	"./frontend/Iframe copy.vue": 34991,
	"./frontend/Iframe.vue": 77908,
	"./frontend/Index.vue": 96390,
	"./frontend/Live.vue": 22281,
	"./frontend/LiveScore.vue": 8496,
	"./frontend/MainMenu.vue": 79248,
	"./frontend/MatchResult.vue": 15234,
	"./frontend/MaungFB.vue": 88416,
	"./frontend/Promotion.vue": 59683,
	"./frontend/Setting.vue": 46494,
	"./frontend/VideoLink.vue": 6375,
	"./frontend/VipLevels.vue": 54654,
	"./frontend/Withdraw.vue": 28424,
	"./frontend/auth/Login.vue": 37706,
	"./frontend/auth/Register.vue": 50897,
	"./frontend/auth/Rule.vue": 33763,
	"./frontend/auth/Verify.vue": 12708,
	"./frontend/auth/VerifyNotAuth.vue": 24085,
	"./frontend/components/AccountSelect.vue": 33725,
	"./frontend/components/AppHeader.vue": 5144,
	"./frontend/components/DataTable.vue": 36469,
	"./frontend/components/FBPreviewVoucher.vue": 17032,
	"./frontend/components/FBVoucher.vue": 19572,
	"./frontend/components/FootballTeamCard.vue": 39495,
	"./frontend/components/GroupBox.vue": 24318,
	"./frontend/components/HomeBanner.vue": 96488,
	"./frontend/components/InputSelectDrawModal.vue": 92334,
	"./frontend/components/LuckyWheel.vue": 33807,
	"./frontend/components/NormalBox.vue": 86123,
	"./frontend/components/PreviewVoucher.vue": 57337,
	"./frontend/components/SideNav.vue": 30850,
	"./frontend/components/Table.vue": 65418,
	"./frontend/components/ThreedGroupBox.vue": 80595,
	"./frontend/components/TwoDSelect.vue": 39403,
	"./frontend/components/Voucher.vue": 82632,
	"./frontend/normal-user/2d/2d.vue": 68924,
	"./frontend/normal-user/2d/ClosedDays.vue": 52300,
	"./frontend/normal-user/2d/Home.vue": 56300,
	"./frontend/normal-user/2d/Winner.vue": 87626,
	"./frontend/normal-user/3d/3d.vue": 8123,
	"./frontend/normal-user/3d/Home.vue": 36410,
	"./frontend/normal-user/DreamBooks.vue": 21131,
	"./frontend/normal-user/Index.vue": 56012,
	"./frontend/normal-user/bugyee/Room.vue": 38345,
	"./frontend/normal-user/game/Arcade.vue": 37436,
	"./frontend/normal-user/game/Fishing.vue": 46102,
	"./frontend/normal-user/game/Game.vue": 32806,
	"./frontend/normal-user/game/Slot.vue": 1357,
	"./frontend/normal-user/shankomee/Room.vue": 61017
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5477;